export default __webpack_public_path__ + "static/media/botas-seguridad-hombre.c6833861.png";